@if (show()) {
  <skk-banner type="info" [customIcon]="RefreshIcon">
    <div class="version-banner">
      <span class="version-banner__text" i18n="@@versionBanner.message"
        >A new version of Sklepnik is available.</span
      >
      <button
        type="button"
        class="btn btn--primary btn--sm version-banner__cta"
        [disabled]="isLoading()"
        (click)="reload()"
        i18n="@@versionBanner.cta"
      >
        Refresh
      </button>
    </div>
  </skk-banner>
}
